// extracted by mini-css-extract-plugin
export default {"title":"GlobalSponsor_title_qqpCc","sponsor":"GlobalSponsor_sponsor_SYaOM"};